<ng-container *ngIf="data.component === 'Policy'">
    <div class="py-2 px-3">
        <h1 mat-dialog-title *ngIf="!propertyPoliciesExist">Delete Policy</h1>
        <h1 mat-dialog-title *ngIf="propertyPoliciesExist">Unable To Delete Policy</h1>
        <div mat-dialog-content class="my-3" *ngIf="!propertyPoliciesExist">
            <div *ngIf="primaryPolicySelected" class="mb-3" style="font-weight:bold;">
                Policy to be deleted is currently the Primary Property policy.
            </div>
            <div>Please confirm you would like to delete this policy?  This action cannot be undone.</div>
            <div class="mt-3">Are you sure you would like to proceed?</div>
        </div>
        <div mat-dialog-content class="my-3" *ngIf="propertyPoliciesExist">
            <div>This policy is unable to be deleted because it is assigned to one or more properties.</div>
            <div class="mt-3">Please remove this policy from all properites before proceeding.</div>
        </div>
        <div mat-dialog-actions class="my-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onNoClick()">
                Cancel
            </button>
            <button mat-raised-button class="warn-button" (click)="onConfirmClick()" [disabled]="propertyPoliciesExist">
                Delete
            </button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="data.component === 'Verification Package'">
    <div class="py-2 px-3">
        <h1 mat-dialog-title>Delete Verification Package</h1>
        <div mat-dialog-content class="my-3">
            <div>Please confirm you would like to delete this verification package?  This action cannot be undone.</div>
            <div class="mt-3">Are you sure you would like to proceed?</div>
        </div>
        <div mat-dialog-actions class="my-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onNoClick()">
                Cancel
            </button>
            <button mat-raised-button class="warn-button" (click)="onConfirmClick()">
                Delete
            </button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="data.component === 'Bad Guest'">
    <div class="py-2 px-3">
        <h1 mat-dialog-title>Delete Bad Guest</h1>
        <div mat-dialog-content class="my-3">
            <div>Please confirm you would like to delete this bad guest?  This action cannot be undone.</div>
            <div class="mt-3">Are you sure you would like to proceed?</div>
        </div>
        <div mat-dialog-actions class="my-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onNoClick()">
                Cancel
            </button>
            <button mat-raised-button class="warn-button" (click)="onConfirmClick()">
                Delete
            </button>
        </div>
    </div>
</ng-container>